<template>
  <chart-card title="Faturamento" filter-button :filter-type.sync="filterType" :data="chartData" :loader="['faturamento']" is-currency legends />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    listaFaturamentoMensal: [],
    listaFaturamentoSemanal: [],
    listaFaturamentoDiario: [],
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        profissional: this.$route.params.id,
      }
    },
    faturamentoMensal() {
      return helpers.agrupamentoMensal(this.listaFaturamentoMensal, 'VAL_FATURAMENTO_IDENTIFICADOS')
    },
    faturamentoSemanal() {
      return helpers.agrupamentoSemanal(this.listaFaturamentoSemanal, 'VAL_FATURAMENTO_IDENTIFICADOS')
    },
    faturamentoDiario() {
      return helpers.agrupamentoDiario(this.listaFaturamentoDiario, 'VAL_FATURAMENTO_IDENTIFICADOS')
    },
    faturamentoIdentificadoMensal() {
      return helpers.agrupamentoMensal(this.listaFaturamentoMensal, 'VAL_FATURAMENTO_TOTAL')
    },
    faturamentoIdentificadoSemanal() {
      return helpers.agrupamentoSemanal(this.listaFaturamentoSemanal, 'VAL_FATURAMENTO_TOTAL')
    },
    faturamentoIdentificadoDiario() {
      return helpers.agrupamentoDiario(this.listaFaturamentoDiario, 'VAL_FATURAMENTO_TOTAL')
    },
    faturamento() {
      if (this.filterType === 'mensal') return this.faturamentoMensal
      if (this.filterType === 'semanal') return this.faturamentoSemanal
      if (this.filterType === 'diario') return this.faturamentoDiario
      return ''
    },
    faturamentoIdentificado() {
      if (this.filterType === 'mensal') return this.faturamentoIdentificadoMensal
      if (this.filterType === 'semanal') return this.faturamentoIdentificadoSemanal
      if (this.filterType === 'diario') return this.faturamentoIdentificadoDiario
      return ''
    },
    chartData() {
      const arrayIdentificado = cloneDeep(this.faturamentoIdentificado)
      const array = cloneDeep(this.faturamento)
      if (arrayIdentificado.length > array.length) {
        const lengthDifference = arrayIdentificado.length - array.length
        for (let i = 0; i < lengthDifference; i++) {
          array.unshift({})
        }
      }
      return {
        labels: [...array.map((object) => object.data)],
        datasets: [
          {
            label: 'Faturamento',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...array.map((object) => object.valor)],
            fill: false,
          },
          {
            label: 'Faturamento Identificado',
            backgroundColor: colors[1],
            strokeColor: colors[1],
            borderColor: colors[1],
            data: [...arrayIdentificado.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  async mounted() {
    await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      clubePercentualFaturamentoIdentificadoChart: 'faturamento',
    }),
    getData() {
      this.clubePercentualFaturamentoIdentificadoChart({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
        this.listaFaturamentoMensal = data
      })
      this.clubePercentualFaturamentoIdentificadoChart({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
        this.listaFaturamentoSemanal = data
      })
      this.clubePercentualFaturamentoIdentificadoChart({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
        this.listaFaturamentoDiario = data
      })
    },
  },
}
</script>
